module.exports = __webpack_public_path__ + "80ae2900d60d939b449178c5bf5e74a5.svg";